var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hi"},[_vm._v(_vm._s(_vm.i18n.helloworld))])
}
var staticRenderFns = []

export { render, staticRenderFns }